import { Parser } from "../text/lexer/parsing/Parser";
import { RJLexing } from "./phases/RJLexing";
import { RJCheckUnknowns } from "./phases/RJCheckUnknowns";
import { RJCreateTokens } from "./phases/RJCreateTokens";
import { RJValidateTokens } from "./phases/RJValidateTokens";
import { RJOperatorsProcessor } from "./phases/RJOperatorsProcessor";

export class RJParser extends Parser
{
  readonly lexing             = new RJLexing( this );
  readonly checkUnknowns      = new RJCheckUnknowns( this );
  readonly createTokens       = new RJCreateTokens( this );
  readonly validateTokens     = new RJValidateTokens( this );
  
  protected _operatorsProcessor:RJOperatorsProcessor;
  get operatorProcessor()
  {
    return this._operatorsProcessor;
  }

  constructor()
  {
    super();
  }

  _initialize()
  {
    this._add( this.lexing );
    this._add( this.checkUnknowns )
    this._add( this.createTokens );
    this._add( this._operatorsProcessor );
  }

}